<div class="home" data-testid="soleil-nyakiriza-bi-home-container">

  <!-- Decorative top bar (not a functional nav) -->
  <div class="top-bar">
    <div class="top-brand">
      <img
        class="flag"
        src="https://oes-hosted-images-public.s3.us-east-1.amazonaws.com/burundi/soleil-burundi-flag.png"
        alt="Burundi"
      />
      <div class="top-brand-text">
        <span class="country">{{ 'home-soleil-nyakiriza-bi.ministry-country' | translate }}</span>
        <span class="ministry">{{ 'home-soleil-nyakiriza-bi.ministry-name' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Hero -->
  <div class="hero">
    <div class="hero-overlay"></div>

    <img
      class="hero-icon"
      src="https://oes-hosted-images-public.s3.us-east-1.amazonaws.com/burundi/burundi-coat-of-arms.svg"
      alt="Projet Soleil Nyakiriza"
    />

    <div class="hero-logo-card">
      <img
        src="https://oes-hosted-images-public.s3.us-east-1.amazonaws.com/burundi/soleil-logo.png"
        alt="Projet Soleil Nyakiriza"
      />
    </div>

    <div class="hero-content">
      <div class="hero-badge">
        <span class="dot"></span>
        {{ 'home-soleil-nyakiriza-bi.badge' | translate }}
      </div>

      <h1 class="hero-title">
        <span class="lead">{{ 'home-soleil-nyakiriza-bi.title-lead' | translate }}</span>
        <span class="main">{{ 'home-soleil-nyakiriza-bi.title-main' | translate }}</span>
      </h1>

      <p class="hero-desc">{{ 'home-soleil-nyakiriza-bi.description' | translate }}</p>

      <div class="hero-actions">
        <button class="btn btn-primary" [routerLink]="['../finance/programs']">
          {{ 'home-soleil-nyakiriza-bi.cta-secondary' | translate }}
          <span class="arrow">&#8594;</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-support">
      <span class="support-label">{{ 'home-soleil-nyakiriza-bi.support-label' | translate }}</span>
      <img
        class="wb-logo"
        src="https://oes-hosted-images-public.s3.us-east-1.amazonaws.com/burundi/soleil-wb-logo.png"
        alt="World Bank Group"
      />
    </div>
    <div class="footer-copy">
      {{ 'home-soleil-nyakiriza-bi.copyright' | translate }}
    </div>
  </div>

</div>
